import React from "react";
import { styled } from "styled-components";

import { IAuctionExpectedOrderProps } from "./lib/DataTable.type";
import { AnimatedWrapper } from "./lib/animationStyle";

const AuctionExpectedOrderPreview = ({ auctionData }: IAuctionExpectedOrderProps) => {
    const { estimatedDividend, auctionPriceNoDataMessageType } = auctionData;

    const isNodata = auctionPriceNoDataMessageType === 4 || auctionPriceNoDataMessageType === 5;

    return (
        <AnimatedWrapper>
            <Wrapper>
                <Header>
                    <h4>예상 배당순서</h4>
                </Header>
                <Table>
                    {!isNodata ? (
                        <>
                            <TableHead>
                                <p className="title1Td colorWhite">권리 종류</p>
                                <p className="colorWhite">|</p>
                                <p className="title2Td colorWhite">배당자</p>
                                <p className="colorWhite">|</p>
                                <p className="title3Td colorWhite">예상 배당액</p>
                                <p className="colorWhite">|</p>
                                <p className="title4Td colorWhite">배당 후 잔액</p>
                            </TableHead>
                            <ContentList>
                                {estimatedDividend?.dividendOrderTable.dividendOrder.map((order) => (
                                    <>
                                        <ContentLayout>
                                            <Content>{order.rightsTypes}</Content>
                                            <Content>{order.dividend}</Content>
                                            <Content>{order.dividendAmount}</Content>
                                            <Content>{order.balance}</Content>
                                            <Content>배당비율</Content>
                                            <Content>미배당금액</Content>
                                            <Content>
                                                {typeof order.dividendRatio === "number"
                                                    ? `${order.dividendRatio.toFixed(2)}%`
                                                    : order.dividendRatio}
                                            </Content>
                                            <Content>{order.undistributedAmount}</Content>
                                        </ContentLayout>
                                    </>
                                ))}
                            </ContentList>
                        </>
                    ) : (
                        <NoDataContent>
                            예상 배당표 관련 정보는 매각물건명세서가 제공된 이후 시점 매각기일 7일전부터 제공됩니다
                        </NoDataContent>
                    )}
                </Table>
            </Wrapper>
        </AnimatedWrapper>
    );
};

const Wrapper = styled.main`
    display: flex;
    flex-direction: column;
    gap: 14px;
`;

const Header = styled.header`
    display: flex;
    justify-content: space-between;

    & > h4 {
        font-size: 18px;
        font-weight: 600;
        line-height: 28px;
        text-align: left;
    }
`;

const Table = styled.table`
    display: flex;
    flex-direction: column;
    width: 100%;
    border-spacing: 0;
    position: relative;
`;

const TableHead = styled.section`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
    height: 32px;
    background: #17366d;
    margin-bottom: 14px;

    .colorWhite {
        color: white;
    }

    & p {
        font-size: 14px;
        font-weight: 600;
        color: white;
    }

    .title1Td {
        width: calc(20% - 4px);
        text-align: center;
    }
    .title2Td {
        width: calc(16% - 4px);
        text-align: center;
    }
    .title3Td {
        width: calc(32% - 4px);
        text-align: center;
    }
    .title4Td {
        width: calc(32% - 4px);
        text-align: center;
    }
`;

const ContentList = styled.section`
    display: flex;
    flex-direction: column;
    gap: 14px;
`;

const ContentLayout = styled.article`
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    & div {
        box-sizing: border-box;
        border-collapse: collapse;
        min-height: 32px;
    }

    & div:nth-child(-n + 4) {
        /* width: calc(25% - 1.2px); // minus border-size */
        width: 25%;
    }

    & div:nth-child(n + 5):nth-child(-n + 6) {
        background-color: #c9c9c9;
    }

    & div:nth-child(n + 5):nth-child(-n + 8) {
        /* width: calc(50% - 1.2px); // minus border-size */
        width: 50%;
    }

    & div:nth-child(1) {
        /* width: calc(21% - 1.2px); */
        width: 20%;
    }

    & div:nth-child(2) {
        /* width: calc(19% - 5.2px); // border-size[0.6px * 2] + padding-size(left)[4px] */
        width: 16%;
        text-align: left;
        padding-left: 4px;
    }

    & div:nth-child(3) {
        /* width: calc(30% - 5.2px); // border-size[0.6px * 2] + padding-size(left)[4px] */
        width: 32%;
        justify-content: flex-end;
        padding-right: 4px;
    }

    & div:nth-child(4) {
        /* width: calc(30% - 5.2px); // border-size + padding-size(left) */
        width: 32%;
        justify-content: flex-end;
        padding-right: 4px;
    }
`;

const Content = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #8d8d8d;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
`;

const NoDataContent = styled.div`
    border: none !important;
    border-radius: 14px;
    background-color: #f0f0f0;
    padding: 14px;
    color: #8d8d8d;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    text-align: center;
`;

export default AuctionExpectedOrderPreview;
